var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.904 0L10.702 1.266L4.702 4.734L2.5 6V18L4.702 19.266L10.757 22.734L12.959 24L15.161 22.734L21.106 19.266L23.308 18V6L21.106 4.734L15.106 1.266L12.904 0ZM4.61211 17L20.2008 17.5V11L21.1121 7L4.61211 17Z",
    fill: "#11B55F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi2);
export default __webpack_public_path__ + "static/media/Ai2.e119ee62c2bf51a4f295e7cde1e0008d.svg";
export { ForwardRef as ReactComponent };